import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

const SnackIcon: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 35 40" {...props}>
      <path
        d="M19.1155 14.6024L19.3336 9.46727C19.3611 8.82427 18.8469 8.28809 18.2033 8.28809H1.16556C0.521957 8.28809 0.00804858 8.82427 0.0352088 9.46727L0.253407 14.6024H19.1155Z"
        fill="#E8F1FF"
      />
      <path
        d="M3.55597 8.28809H1.16556C0.521957 8.28809 0.00804858 8.82427 0.0352088 9.46727L0.253406 14.6024H2.64382L2.42562 9.46727C2.39846 8.82427 2.91237 8.28809 3.55597 8.28809Z"
        fill="#CFD7E4"
      />
      <path
        d="M5.83903 31.8324C5.83903 27.3223 9.09857 24.0624 13.6087 24.0624C15.4324 24.0624 17.1163 24.6606 18.4756 25.6707C18.4753 25.6707 18.4753 25.6707 18.4753 25.6704C18.5113 25.6368 18.5485 25.6045 18.5851 25.5718L19.1201 14.4443H0.244629L1.18059 36.4756H7.28707C6.3743 35.1569 5.83903 33.5575 5.83903 31.8324Z"
        fill="#F25C5C"
      />
      <path
        d="M0.244629 14.4443L1.18059 36.4756H3.571L2.63504 14.4443H0.244629Z"
        fill="#E54A4A"
      />
      <path
        d="M7.44877 36.4746H1.18359L1.28705 38.9145C1.31299 39.5202 1.81133 39.9978 2.4174 39.9978H13.691C10.9061 39.9978 8.92274 38.6032 7.44877 36.4746Z"
        fill="#E54A4A"
      />
      <path
        d="M3.67776 38.9148L3.574 36.4746H1.18359L1.28705 38.9148C1.31299 39.5205 1.81133 39.9981 2.4174 39.9981H4.80812C4.20174 39.9981 3.7034 39.5205 3.67776 38.9148Z"
        fill="#D83F3F"
      />
      <path
        d="M7.44075 26.9096L6.07358 2.95488C6.03849 2.29144 5.61064 1.72047 4.98351 1.50105L0.79137 0.0334775C0.481621 -0.0748584 0.14227 0.0884083 0.0336292 0.398157C-0.0750119 0.708212 0.0882549 1.04726 0.398309 1.1559L4.59045 2.62347C4.76043 2.68298 4.8764 2.8377 4.88616 3.02019L6.34915 28.6567C6.63937 28.0272 7.0071 27.4406 7.44075 26.9096Z"
        fill="#E8F1FF"
      />
      <path
        d="M27.0731 23.667C26.4274 23.667 25.8036 23.7866 25.2152 24.0091C24.9095 24.1247 24.5744 24.1247 24.2686 24.0091C23.6802 23.7866 23.0565 23.667 22.4107 23.667C20.966 23.667 19.4734 24.2648 18.3965 25.2749C20.399 26.7633 21.6966 29.147 21.6966 31.8334C21.6966 34.5201 20.399 36.9035 18.3965 38.3918C19.4734 39.4019 20.966 39.9998 22.4107 39.9998C23.0565 39.9998 23.6799 39.8801 24.2686 39.6577C24.5744 39.542 24.9091 39.542 25.2152 39.6577C25.8036 39.8801 26.4271 39.9998 27.0728 39.9998C27.1674 39.9998 27.2611 39.9967 27.3548 39.9915C26.0899 39.7419 24.9796 38.6698 24.9796 37.1827C24.9796 35.6267 26.0032 34.6034 27.559 34.6034C28.4006 34.6034 29.1553 34.9727 29.6717 35.5577C30.1877 34.9727 30.9427 34.6034 31.7844 34.6034C32.272 34.6034 32.7307 34.648 33.1308 34.8662C33.3972 33.972 33.5434 32.845 33.5434 31.8334C33.5431 27.3233 30.6464 23.667 27.0731 23.667Z"
        fill="#6FD844"
      />
      <path
        d="M20.6789 23.9443C19.8354 24.2138 19.0413 24.6691 18.3965 25.274C20.399 26.7623 21.6966 29.1457 21.6966 31.8324C21.6966 34.5191 20.399 36.9025 18.3965 38.3909C19.0413 38.9957 19.8354 39.451 20.6786 39.7205C22.8578 37.7872 24.2338 34.9677 24.2338 31.8324C24.2338 28.6971 22.8578 25.8776 20.6789 23.9443Z"
        fill="#5FBF32"
      />
      <path
        d="M24.7422 24.6885C24.4136 24.6885 24.1475 24.4224 24.1475 24.0938C24.1475 20.1155 26.0856 18.5216 26.168 18.4557C26.4247 18.2506 26.7988 18.2928 27.0039 18.5494C27.2077 18.8045 27.1674 19.1765 26.9141 19.3819C26.8424 19.4417 25.3367 20.7372 25.3367 24.0938C25.3367 24.4224 25.0706 24.6885 24.7422 24.6885Z"
        fill="#A56E58"
      />
      <path
        d="M21.8572 31.8334C21.8572 36.3435 18.2009 39.9998 13.6908 39.9998C9.18067 39.9998 5.52441 36.3435 5.52441 31.8334C5.52441 27.3233 9.18067 23.667 13.6908 23.667C18.2009 23.667 21.8572 27.3233 21.8572 31.8334Z"
        fill="#FEB644"
      />
      <path
        d="M7.91635 31.8334C7.91635 27.7294 10.9437 24.3332 14.8868 23.7546C14.4965 23.6972 14.0973 23.667 13.6908 23.667C9.18067 23.667 5.52441 27.3233 5.52441 31.8334C5.52441 36.3435 9.18067 39.9998 13.6908 39.9998C14.0973 39.9998 14.4965 39.9696 14.8868 39.9125C10.9437 39.3336 7.91635 35.9373 7.91635 31.8334Z"
        fill="#F9972D"
      />
      <path
        d="M13.6882 24.6885C13.3599 24.6885 13.0938 24.4224 13.0938 24.0938C13.0938 20.1155 15.0316 18.5216 15.1143 18.4557C15.3709 18.2506 15.7451 18.2928 15.9502 18.5494C16.154 18.8045 16.1134 19.1765 15.8601 19.3819C15.7887 19.4417 14.283 20.7372 14.283 24.0938C14.283 24.4224 14.0169 24.6885 13.6882 24.6885Z"
        fill="#A56E58"
      />
      <path
        d="M31.787 34.3647C30.9454 34.3647 30.032 34.7343 29.5156 35.3193C29.9539 35.8158 30.2203 36.4677 30.2203 37.1821C30.2203 37.8965 29.9539 38.548 29.5156 39.0446C30.032 39.6296 30.9454 39.9991 31.787 39.9991C33.3428 39.9991 34.6041 38.7379 34.6041 37.1821C34.6041 35.626 33.3428 34.3647 31.787 34.3647Z"
        fill="#E54A4A"
      />
      <path
        d="M29.5156 35.3193C29.9539 35.8158 30.2203 36.4677 30.2203 37.1821C30.2203 37.8962 29.9539 38.548 29.5156 39.0446C30.032 39.6299 30.9454 39.9991 31.7867 39.9991C31.8337 39.9991 31.8801 39.9979 31.9262 39.9958C32.4514 39.184 32.7575 38.2185 32.7575 37.1821C32.7575 36.1457 32.4514 35.1799 31.9262 34.3684C31.8801 34.366 31.8337 34.3647 31.7867 34.3647C30.9454 34.3647 30.032 34.7343 29.5156 35.3193Z"
        fill="#D83F3F"
      />
      <path
        d="M30.3785 37.1821C30.3785 38.7379 29.1172 39.9991 27.5612 39.9991C26.0054 39.9991 24.7441 38.7379 24.7441 37.1821C24.7441 35.626 26.0054 34.3647 27.5612 34.3647C29.1172 34.3647 30.3785 35.626 30.3785 37.1821Z"
        fill="#F25C5C"
      />
      <path
        d="M27.1358 37.1821C27.1358 36.0539 27.7992 35.081 28.7571 34.6312C28.3943 34.4606 27.989 34.3647 27.5612 34.3647C26.0054 34.3647 24.7441 35.626 24.7441 37.1818C24.7441 38.7379 26.0054 39.9991 27.5612 39.9991C27.989 39.9991 28.394 39.9033 28.7571 39.7327C27.7992 39.2829 27.1358 38.3103 27.1358 37.1821Z"
        fill="#E54A4A"
      />
      <path
        d="M32.1593 34.4535C32.134 34.4331 29.627 32.3735 29.0103 29.5616C28.9401 29.2409 28.6227 29.0379 28.302 29.1081C27.9812 29.1783 27.7783 29.4954 27.8485 29.8164C27.9693 30.3676 28.1506 30.8891 28.3667 31.3771L27.0099 34.6906C26.8853 34.9946 27.0309 35.3415 27.3349 35.4664C27.4087 35.4966 27.485 35.5106 27.5601 35.5106C27.7942 35.5106 28.0163 35.3715 28.1106 35.1414L29.0981 32.7296C30.1208 34.3232 31.3354 35.3168 31.412 35.3788C31.6671 35.5848 32.0409 35.5448 32.2475 35.2897C32.4538 35.0345 32.4141 34.6604 32.1593 34.4535Z"
        fill="#A56E58"
      />
    </SvgIcon>
  );
};

export default SnackIcon;
